//------------------
// is count changed
//------------------
export default function isCountChanged(original, now) {
  console.log('----------------------------')
  console.log('IN isCountChanged')

  console.log('ORIGINAL COUNT: ', original)
  console.log('NOW COUNT: ', now)

  if (
    original.name != now.name ||
    original.value != now.value
  ) {
    console.log('VALUE CHANGED ', original.name)
    return true
  } else {
    console.log('VALUE NOT CHANGED ', original.name)
    return false
  }
}
